import { Component, OnInit } from '@angular/core';
import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './liquid-types.component.html',
    standalone: false
})
export class LiquidTypesModalComponent extends BaseModalDirective implements OnInit {
    globalLang: string;

    ngOnInit(): void {
        this.globalLang = sessionStorage.getItem('globalTranslatedLan');
    }

    isGlobalLang(): boolean {
        return this.globalLang === 'de' || this.globalLang === 'fr' || this.globalLang === 'ru';
    }

}
